import axios from 'axios'
import {jsonHeader} from '@/helpers/axiosHeaders'
import qs from "qs";
const state = {
    items: {},
    titleTemplate: '%s',
}

// getters
const getters = {
    setRouble() {
        let rouble = detectOS() ? 'Р' : '₽';

        const symbolRouble = rouble;
        return symbolRouble;
    }
}

const actions = {
    getList(context, data) {
        return new Promise((resolve, reject) => {
            axios.get(process.env.VUE_APP_API_PATH+'/public/options/',{
                headers: jsonHeader,
            }).then(response => {
                if(typeof response.data === 'object' && +response.data.error === 0) {
                    context.commit('setOption', response.data.result);
                    resolve();
                }
            }).catch(function (error) {
                context.commit('popups/open', {name: context.rootState.popups.items.somethingWentWrong.name}, {root: true});
                reject();
            });
        });
    },
}

const mutations = {
    setOption(state, data) {
        if(typeof data === 'object') {
            state.items = data.items;
        }
    },
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

function detectOS() {
    let thisUserAgent = window.navigator.userAgent;
    let OS = thisUserAgent.indexOf("iPhone OS") != -1 || thisUserAgent.indexOf("Windows NT 6.1") != -1 || thisUserAgent.indexOf("iPad") != -1 || (thisUserAgent.indexOf('Macintosh') > -1 && 'ontouchend' in document);

    return OS;
}
